import {
  TabsProps as MantineTabsProps,
  Tabs as MantineTabs,
  TabsListProps as MantineTabsListProps,
  TabsList as MantineTabsList,
  TabsTabProps as MantineTabsTabProps,
  TabsTab as MantineTabsTab,
  TabsPanelProps as MantineTabsPanelProps,
  TabsPanel as MantineTabsPanel,
} from '@mantine/core';

export type TabsProps = MantineTabsProps;
export type TabsListProps = MantineTabsListProps;
export type TabsTabProps = MantineTabsTabProps;
export type TabsPanelProps = MantineTabsPanelProps;

export const Tabs = MantineTabs;
Tabs.displayName = 'Tabs';

export const TabsList = MantineTabsList;
TabsList.displayName = 'TabsList';

export const TabsTab = MantineTabsTab;
TabsTab.displayName = 'TabsTab';

export const TabsPanel = MantineTabsPanel;
TabsPanel.displayName = 'TabsPanel';

// Attach subcomponents to Tabs for dot notation access
Tabs.List = TabsList;
Tabs.Tab = TabsTab;
Tabs.Panel = TabsPanel;
